import Token from '@/di/di.token'

import useService from './useService'

export default function useMediaGroupService() {
  const { service } = useService(Token.MEDIA_GROUP_SERVICE)
  return { service }
}
